// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__RvqFn","text":"styles_text__W+qyB","flag":"styles_flag__Z7ZXK"};